import vars from '../../vars';

$(document).ready(function() {
    $('.b-longrid-menu__close').on('click', (e) => {
        $('.b-longrid-menu').removeClass('show');
        $('.b-longrid-menu__close').removeClass('show');
    	$('body').removeClass('fixed-position-modal');
    });
    $('.js-menu-open').on('click', (e) => {
    	$('.b-longrid-menu').addClass('show');
        $('.b-longrid-menu__close').addClass('show');
	    if($(window).width() < 1024) {
	    	$('body').addClass('fixed-position-modal');
	    }
    });
});


// WEBPACK FOOTER //
// ./src/js/pages/longrid/longrid-menu.js